<base href="/">

<!-- main app container -->
<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>

<app-footer></app-footer>